import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import SectionHeader from './../common/sectionHeader';
import Button from './../common/button';
import PricingCard from './../common/pricingCard';

const Section = Styled.section.attrs((props) => ({ id: 'pricing' }))`
padding: 8rem 0;
background: ${color.white};
}`;

const PricingWrapper = Styled.div`
display: grid;
grid-template-columns: repeat(3, max-content);
place-items:center;
place-content:center;
grid-gap: 4rem;
margin: 7rem 0;
@media only screen and (max-width: 700px){
grid-template-columns: repeat(1, max-content);
grid-row-gap: 6rem;
}
`;
const Footer = Styled.footer`
text-align:center;
`;

const Pricing = ({ items }) => {
  return (
    <Section>
      <SectionHeader
        heading={'Affordable options, tailored to your needs'}
        paragraph={
          'All services include live updates including photos and chat, as well as notifications of sitter arrival and departure times.'
        }
      />
      <PricingWrapper>
        {items.map((item) => (
          <PricingCard
            key={item.type}
            image={item.icon}
            brief={item.brief}
            type={item.type}
            price={item.price}
            paragraph={item.description}
          />
        ))}
      </PricingWrapper>
      <Footer>
        <Button
          link={{ path: '/schedule' }}
          text={'Schedule a service'}
          type={'primary'}
          rounded
        />
      </Footer>
    </Section>
  );
};

export default Pricing;
